/**
 * Two letters standing in for a face.
 *
 * A full name gives its first and last initial; a lone name or an email address gives its first
 * letter. Upper-cased for Latin, which Arabic simply ignores.
 *
 * Shared because the top bar and the customer list both need it, and two copies of a rule about
 * how people's names are shortened is two places for it to drift.
 */
export function initials(fullName?: string | null, email?: string | null) {
  const words = (fullName ?? '').trim().split(/\s+/).filter(Boolean);

  const first = words[0];
  const last = words[words.length - 1];

  if (first && last && words.length >= 2) {
    return `${first[0]}${last[0]}`.toUpperCase();
  }

  return (first?.[0] ?? email?.[0] ?? '?').toUpperCase();
}
